export const gfInitState = {
  value: false,
};
